"use client";

import type { BuilderBlock, BuilderContextInterface, RegisteredComponents } from "@builder.io/sdk-react";
import { Blocks } from "@builder.io/sdk-react";

import { useConfig } from "@jti/app-context/useConfig";
import { InnerContainer as UIInnerContainer } from "@jti/ui/eva-components/Header/components/SecondaryNavigation/components/InnerContainer/InnerContainer";
import { InnerContainer as MobileFirstUIInnerContainer } from "@jti/ui/eva-components/MobileFirstHeader/components/SecondaryNavigation/components/InnerContainer/InnerContainer";

type InnerContainerBuilderProps = {
  builderBlock: BuilderBlock;
  builderContext: BuilderContextInterface;
  builderComponents: RegisteredComponents;
};

export function InnerContainer({ builderBlock, builderContext, builderComponents }: InnerContainerBuilderProps) {
  const { isMobileFirstNavigationEnabled } = useConfig();
  const InnerContainerComponent = isMobileFirstNavigationEnabled ? MobileFirstUIInnerContainer : UIInnerContainer;

  return (
    <InnerContainerComponent>
      {builderBlock?.children?.map((child) => (
        <Blocks
          key={child.id}
          blocks={[child]}
          parent={builderBlock?.id}
          path="children"
          context={builderContext}
          registeredComponents={builderComponents}
        />
      ))}
    </InnerContainerComponent>
  );
}
